import { useMemo } from "react";
import { useEntities } from "@hooks/useEntities";

export function useEntitiesWithAccountingAvailable() {
    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    return useMemo(
        () => entities.filter((e) => !!e.legalType && e.isBusiness),
        [entities],
    );
}
